import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, CheckboxComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mbs-immutability-not-defined-modal',
  templateUrl: './immutability-not-defined.component.html',
  imports: [CommonModule, ButtonComponent, ReactiveFormsModule, I18NextPipe, ModalComponent, CheckboxComponent, ModalFooterDirective]
})
export class ImmutabilityNotDefinedComponent {
  public readonly mbsPopupType = MbsPopupType;
  public confirmed = new FormControl(false);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  confirmClickHandler(): void {
    this.baseModal.save(true);
  }

  cancelClickHandler(): void {
    this.baseModal.close();
  }
}
